// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"UserSubscriptionsPanel_footerContainer__24ljQ","saveButtonSpinner":"UserSubscriptionsPanel_saveButtonSpinner__2TpvP"};